import React from 'react';
import { useLanguage } from '../i18nContext';
import StaticPageLayout from './StaticPageLayout';
import { Briefcase, MapPin, Clock } from 'lucide-react';

interface Props { onBack: () => void; }

const jobs = [
  { titleEn: 'Senior AI/ML Engineer', titleZh: '高级 AI/ML 工程师', locEn: 'Remote / Beijing', locZh: '远程 / 北京', typeEn: 'Full-time', typeZh: '全职', descEn: 'Build and optimize our ASR and NLP pipeline for meeting intelligence.', descZh: '构建和优化我们的 ASR 和 NLP 会议智能流水线。' },
  { titleEn: 'Full-Stack Engineer', titleZh: '全栈工程师', locEn: 'Remote / Beijing', locZh: '远程 / 北京', typeEn: 'Full-time', typeZh: '全职', descEn: 'Work on our React frontend and Spring Boot backend to deliver seamless user experiences.', descZh: '参与 React 前端和 Spring Boot 后端开发，打造流畅的用户体验。' },
  { titleEn: 'Product Designer', titleZh: '产品设计师', locEn: 'Remote', locZh: '远程', typeEn: 'Full-time', typeZh: '全职', descEn: 'Design intuitive interfaces for complex meeting intelligence workflows.', descZh: '为复杂的会议智能工作流设计直观的界面。' },
];

export default function CareersPage({ onBack }: Props) {
  const { language } = useLanguage();
  const en = language === 'en';

  return (
    <StaticPageLayout title={en ? 'Careers' : '加入我们'} onBack={onBack}>
      <div className="text-center mb-16">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-brand-900/10 mb-6">
          <Briefcase size={32} className="text-brand-900" />
        </div>
        <h2 className="text-4xl font-bold text-brand-900 font-serif mb-4">
          {en ? 'Join Our Team' : '加入我们的团队'}
        </h2>
        <p className="text-lg text-ink-secondary max-w-2xl mx-auto">
          {en ? 'Help us build the future of meeting intelligence. We are looking for passionate people who care about precision and craft.' : '帮助我们构建会议智能的未来。我们正在寻找热爱精准和匠心的伙伴。'}
        </p>
      </div>

      <div className="space-y-6 mb-16">
        {jobs.map((job, i) => (
          <div key={i} className="bg-white rounded-2xl border border-surface-border p-8 hover:shadow-md transition-shadow">
            <h3 className="text-xl font-bold text-brand-900 mb-3">{en ? job.titleEn : job.titleZh}</h3>
            <div className="flex flex-wrap gap-4 text-sm text-ink-secondary mb-3">
              <span className="flex items-center gap-1"><MapPin size={14} />{en ? job.locEn : job.locZh}</span>
              <span className="flex items-center gap-1"><Clock size={14} />{en ? job.typeEn : job.typeZh}</span>
            </div>
            <p className="text-ink-secondary">{en ? job.descEn : job.descZh}</p>
          </div>
        ))}
      </div>

      <div className="text-center bg-white rounded-2xl border border-surface-border p-12">
        <h3 className="text-2xl font-bold text-brand-900 font-serif mb-4">
          {en ? "Don't see a fit?" : '没有找到合适的职位？'}
        </h3>
        <p className="text-ink-secondary mb-6">
          {en ? 'Send us your resume and tell us how you can contribute.' : '发送您的简历，告诉我们您能如何贡献。'}
        </p>
        <a href="mailto:careers@minutesai.com" className="inline-block bg-brand-900 text-white px-8 py-3 rounded-full font-bold hover:bg-brand-800 transition-colors">
          {en ? 'Send Resume' : '发送简历'}
        </a>
      </div>
    </StaticPageLayout>
  );
}
